module.exports = __webpack_public_path__ + "static/media/03.d7ac5d73.JPG";